import { render, staticRenderFns } from "./TributeSlideTemplateTable.vue?vue&type=template&id=30474eb2&scoped=true"
import script from "./TributeSlideTemplateTable.vue?vue&type=script&lang=js"
export * from "./TributeSlideTemplateTable.vue?vue&type=script&lang=js"
import style0 from "./TributeSlideTemplateTable.vue?vue&type=style&index=0&id=30474eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30474eb2",
  null
  
)

export default component.exports